<template>
  <p class="exhibitionDates" v-if="catalog.begin_year">
    {{$t('pages.results.catalogDates')}} :
    {{catalog.begin_day !== 0 ? catalog.begin_day : ''}} {{getMonth(catalog.begin_month)}} {{catalog.begin_year}}
    -
    {{catalog.end_day !== 0 ? catalog.end_day : ''}} {{getMonth(catalog.end_month)}} {{catalog.end_year}}
  </p>
</template>

<script>
export default {
  name: 'exhibitionDates',
  props: ['catalog'],
  methods: {
    getMonth (month) {
      switch (month) {
        case 1:
          return 'janvier'
        case 2:
          return 'février'
        case 3:
          return 'mars'
        case 4:
          return 'avril'
        case 5:
          return 'mai'
        case 6:
          return 'juin'
        case 7:
          return 'juillet'
        case 8:
          return 'août'
        case 9:
          return 'septembre'
        case 10:
          return 'octobre'
        case 11:
          return 'novembre'
        case 12:
          return 'décembre'
        default:
          return null
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalog/CatalogDates.vue